__webpack_require__.p = "/src/skins/kampen/";